import React, { ReactNode } from 'react'
import { FC, PropsWithChildren } from 'react'
import { HeadingTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'

export interface PdSectionTitleProps {
  title: string | string[]
  subTitle?: ReactNode[]
  themeColor?: 'black90' | 'white90' | 'black90_black60'
  align?: 'center' | 'left' | 'right'
  titleSize?: string
  subTitleSize?: string
  subTitleBoxStyle?: string
  titleBoxClass?: string
  noMargin?: boolean
  titleTag?: HeadingTag
}

const themeColorMap = new Map([
  [
    'black90',
    {
      titleColor: 'text-black/90',
      subTitleColor: 'text-black/90',
    },
  ],
  [
    'white90',
    {
      titleColor: 'text-white/90',
      subTitleColor: 'text-white/90',
    },
  ],
  [
    'black90_black60',
    {
      titleColor: 'text-black/90',
      subTitleColor: 'text-black/60',
    },
  ],
])

const PdSectionTitle: FC<PropsWithChildren<PdSectionTitleProps>> = ({
  title,
  subTitle,
  themeColor = 'black90',
  align = 'center',
  subTitleBoxStyle,
  titleSize = 'text-24 laptop:text-5xl',
  subTitleSize = 'text-16 laptop:text-sm',
  titleBoxClass,
  noMargin,
  titleTag,
}) => {
  return (
    <div
      className={['w-full flex flex-col items-center gap-3', noMargin ? '' : 'mb-8 laptop:mb-16', 'laptop:gap-6'].join(
        ' '
      )}
    >
      {!!title?.length && (
        <div className={['w-full', titleBoxClass ? titleBoxClass : ''].join(' ')}>
          {(typeof title === 'string' ? [title] : title).map((item, index) => (
            <SemanticText
              key={index}
              as={titleTag}
              defaultTag="h3"
              className={[
                'w-full font-semibold',
                `text-${align}`,
                themeColor === 'white90' ? 'text-white/90' : 'text-fc-primary', // todo：兼容方案，详情页重构后调整
                titleSize,
              ].join(' ')}
            >
              {item}
            </SemanticText>
          ))}
        </div>
      )}
      {!!subTitle?.length && (
        <div className={['w-full', subTitleBoxStyle].join(' ')}>
          {subTitle?.map((item, index) => {
            if (typeof item === 'string') {
              return (
                <p
                  key={index}
                  className={[
                    themeColor === 'white90' ? 'text-white/90' : 'text-fc-secondary', // todo：兼容方案，详情页重构后调整
                    `text-${align}`,
                    subTitleSize,
                    'w-full',
                  ].join(' ')}
                >
                  {item}
                </p>
              )
            }

            return item
          })}
        </div>
      )}
    </div>
  )
}

export default PdSectionTitle
